import {ConsumablePlace} from "@/store/place/types";
import {injectable} from "inversify";
import {PickConsumablePanel} from "@/scenes.ui/pick-consumable-panel";
import Scene = Phaser.Scene;
import {ConsumableInfo} from "@/store/consumable/types";
import ConsumableStore from "@/store/consumable";

@injectable()
export class ConsumableService{



    public openPlace(scene: Scene, canvas: HTMLCanvasElement, consumablePlace: ConsumablePlace,
                     closeCallback: (removePlace: boolean) => unknown) {

        ConsumableStore.consumablePlaceInfo(consumablePlace.id).then((ci: ConsumableInfo) => {

            let pickConsumablePanel = new PickConsumablePanel(scene, canvas, ci, () => closeCallback(false),
                () => {
                    this.takeConsumable(consumablePlace);
                    closeCallback(true);
                });

            pickConsumablePanel.openAnimated();
        })
    }

    public takeConsumable(consumablePlace: ConsumablePlace) {
        ConsumableStore.takeConsumable(consumablePlace.id);
    }

}
